"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECURITY_EXEMPTION_URL_PARAM = exports.SECURITY_EXEMPTION_HEADER = exports.SESSION_REQUIRED_ERROR_CODE = exports.GRACE_TOKEN_TTL_SECONDS = exports.SESSION_TOKEN_TTL_SECONDS = exports.SESSION_ATTEMPT_HEADER = exports.SESSION_REVERIFY_HEADER = exports.SSR_SHARED_SECRET_HEADER = exports.CF_THREAT_SCORE_HEADER = exports.CF_BOT_CATEGORY_HEADER = exports.CF_BOT_CLIENT_BOT_HEADER = exports.CF_BOT_JA3_HEADER = exports.CF_BOT_CORPORATE_PROXY_HEADER = exports.CF_BOT_STATIC_RESOURCE_HEADER = exports.CF_BOT_JS_PASSED_HEADER = exports.CF_BOT_SCORE_HEADER = exports.CF_VERIFIED_BOT_HEADER = exports.CF_FINGERPRINT_HEADER = exports.LEGACY_DEVICE_ID_HEADER = exports.CLIENT_TOKEN_HEADER = exports.SESSION_TOKEN_HEADER = exports.GRACE_TOKEN_HEADER = void 0;
exports.GRACE_TOKEN_HEADER = "x-grace-token";
exports.SESSION_TOKEN_HEADER = "x-session-token";
exports.CLIENT_TOKEN_HEADER = "x-client-token";
exports.LEGACY_DEVICE_ID_HEADER = "x-device-id";
exports.CF_FINGERPRINT_HEADER = "x-zeffy-ja4";
exports.CF_VERIFIED_BOT_HEADER = "x-zeffy-verified-bot";
exports.CF_BOT_SCORE_HEADER = "x-zeffy-bot-score";
exports.CF_BOT_JS_PASSED_HEADER = "x-zeffy-bot-js-passed";
exports.CF_BOT_STATIC_RESOURCE_HEADER = "x-zeffy-bot-static-resource";
exports.CF_BOT_CORPORATE_PROXY_HEADER = "x-zeffy-bot-corporate-proxy";
exports.CF_BOT_JA3_HEADER = "x-zeffy-bot-ja3";
exports.CF_BOT_CLIENT_BOT_HEADER = "x-zeffy-bot-client-bot";
exports.CF_BOT_CATEGORY_HEADER = "x-zeffy-bot-category";
exports.CF_THREAT_SCORE_HEADER = "x-zeffy-threat-score";
exports.SSR_SHARED_SECRET_HEADER = "x-ssr-shared-secret";
exports.SESSION_REVERIFY_HEADER = "x-session-reverify";
exports.SESSION_ATTEMPT_HEADER = "x-session-attempt";
exports.SESSION_TOKEN_TTL_SECONDS = 60 * 10;
exports.GRACE_TOKEN_TTL_SECONDS = 120;
exports.SESSION_REQUIRED_ERROR_CODE = "session-required";
// Carries a backoffice-issued load-test token that exempts the request from the rate limiter, the session check and reCAPTCHA.
exports.SECURITY_EXEMPTION_HEADER = "x-zeffy-security-exemption";
// URL parameter a load-test browser opens the site with; the frontend moves it into SECURITY_EXEMPTION_HEADER.
exports.SECURITY_EXEMPTION_URL_PARAM = "skipSessionVerification";
